module.exports = __webpack_public_path__ + "static/media/work.24324e2b.svg";